import { Badge } from '@one-thd/sui-atomic-components';
import React from 'react';
export var PHOrderBadge = function (_a) {
    var _b, _c, _d;
    var deliveryTrackerData = _a.deliveryTrackerData, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, preShip = _a.preShip;
    var status = (_d = (_c = (_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.statusDescription) !== null && _d !== void 0 ? _d : '';
    var successStatuses = [
        'Being Processed',
        'Processed',
        'Shipped',
        'In-Transit',
        'Reserved',
        'Out for Delivery',
        'On Schedule',
    ];
    if (fulfillmentType === 'InStorePurchase' ||
        fulfillmentType === 'unavailable' ||
        status === 'Canceled' ||
        status === 'Delivered' ||
        status === 'Complete' ||
        (deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.status) === 'DELIVERED' ||
        (!successStatuses.includes(status) && status !== 'See Order Details')) {
        return null;
    }
    var badgeColor = function () {
        if (status === 'See Order Details' ||
            (deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.status) === 'DELAYED')
            return 'warning';
        if (['On Schedule', 'Processed'].includes(status) || preShip)
            return 'primary';
        if (successStatuses.includes(status))
            return 'success';
        return null;
    };
    return (React.createElement("div", { style: {
            marginBottom: '16px',
        } },
        React.createElement(Badge, { variant: "subtle", style: { textTransform: 'capitalize', fontSize: '12px' }, size: "base", color: badgeColor() }, (function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            if ((deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.status) === 'DELAYED') {
                return 'Delayed';
            }
            if (preShip ||
                ((_b = (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.statusDescription) ===
                    'On Schedule') {
                return 'Processed';
            }
            if (((_d = (_c = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.statusDescription) ===
                'Return Initiated') {
                return 'Initiated';
            }
            if (deliveryTrackerData !== undefined) {
                return ((_e = deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.status) !== null && _e !== void 0 ? _e : '')
                    .split('_')
                    .join(' ')
                    .toLowerCase();
            }
            if (((_g = (_f = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.statusDescription) === 'Shipped') {
                return 'Shipped';
            }
            if (((_j = (_h = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.statusDescription) ===
                'Ready for Pickup') {
                return 'Ready for Pickup';
            }
            if (((_l = (_k = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.statusDescription) === 'Delivered') {
                return 'Delivered';
            }
            return (_o = (_m = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.statusDescription;
        })())));
};
